export default "/images/vendor/flag-icon-css/flags/1x1/de.svg?11d88d2b77e6abe5ebb1a7264ad57268";